import Head from "next/head";
import BreadcrumbScroll from "../../../components/Elements/BreadcrumbScroll/BreadcrumbScroll";
import ServerError from "../../../components/Elements/ServerError/ServerError";
import RelatedCategories from "../../../components/NewsCompo/RelatedCategories/RelatedCategories";
import RelatedRow from "../../../components/Elements/RelatedRow/RelatedRow";
import HeaderOfNote from "../../../components/Elements/SingleNote/HeaderOfNote";
import HeaderNoteImage from "../../../components/Elements/SingleNote/HeaderNoteImage";
import SingleNoteContent from "../../../components/Elements/SingleNote/SingleNoteContent";
import {
  newsThumbnailsDeserializer,
  singleNewsDataDeserializer,
} from "../../../components/Services/deserializer";

const SingleNewsPage = ({ newsData, relNewsData, host }) => {
  // const newsData = jsonData !== null ? JSON.parse(jsonData)[0] : null
  const relatedNews = relNewsData !== null ? JSON.parse(relNewsData) : null;
  return (
    <>
      {newsData === null ? (
        <ServerError prevPageLink="/newsroom" />
      ) : (
        <>
          <Head>
            <title>{`${newsData?.title} - اتاق خبر دیجی‌کالا`}</title>
            <meta
              name="viewport"
              content="initial-scale=1.0, width=device-width"
            />
            <meta charSet="utf-8" />
            <meta name="description" content={newsData?.metaDescription} />
            <link rel="icon" type="image/x-icon" href="/faviconNew.svg"></link>
            <meta
              name="robots"
              content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
            />
            <link
              rel="canonical"
              href={`https://about.digikala.com/newsroom/${newsData?.slug}/`}
            />
            <meta property="og:locale" content="fa_IR" />
            <meta property="og:type" content="website" />
            <meta
              property="og:title"
              content={`${newsData?.title} - اتاق خبر دیجی‌کالا`}
            />
            <meta
              property="og:url"
              content={`https://about.digikala.com/newsroom/${newsData?.slug}/`}
            />
            <meta property="og:site_name" content="اتاق خبر دیجی‌کالا" />
            <meta
              property="og:image"
              itemProp="image"
              content={newsData?.ogImage}
            />
            <meta property="og:image:width" content="900" />
            <meta property="og:image:height" content="600" />
            <meta
              property="og:image:alt"
              content={`${newsData?.title} - اتاق خبر دیجی‌کالا`}
            />
            <meta property="og:image:type" content="image/png" />
            <meta
              property="og:site_name"
              content="اتاق خبر دیجی‌کالا"
              key="ogsitename"
            />
            <meta
              property="og:title"
              content={`${newsData?.title} - اتاق خبر دیجی‌کالا`}
              key="ogtitle"
            />
            <meta
              property="og:description"
              content={newsData?.metaDescription}
              key="ogdesc"
            />
            <meta name="twitter:card" content="summary_large_image" />
            <meta
              name="twitter:title"
              content={`${newsData?.metaDescription} - اتاق خبر دیجی‌کالا`}
            />
            <meta name="twitter:site" content="درباره گروه دیجی‌کالا" />
            <meta name="twitter:image" content={newsData?.ogImage} />
            <meta
              name="twitter:description"
              content={newsData?.metaDescription}
            />
          </Head>
          <BreadcrumbScroll
            title={newsData?.title}
            routeOne="/newsroom/"
            titleOne="اتاق خبر"
            routeTwo={`/newsroom/${newsData?.slug}`}
            titleTow={newsData?.title}
          />
          <div className="spacerForbreadCrumb d-flex w-100"></div>
          <HeaderOfNote
            notePath={`https://about.digikala.com/newsroom/${newsData.slug}`}
            noteParagraphContent={newsData?.content}
            noteTypeTitle="خبر"
            categoryTitle={newsData.category.name}
            categoryLink={`/newsroom?cat=${newsData.category.id}`}
            noteDate={newsData.date}
            noteTitle={newsData.title}
          />
          {newsData?.image && (
            <HeaderNoteImage title={newsData?.title} src={newsData?.image} />
          )}

          {newsData?.content && (
            <SingleNoteContent content={newsData?.content} />
          )}

          <RelatedCategories cats={newsData?.categories} />

          {relatedNews?.filter((i) => i.id != newsData?.id)?.length > 0 && (
            <RelatedRow
              rowData={
                relatedNews?.length > 0
                  ? relatedNews
                      ?.filter((i) => i.id != newsData?.id || i.id !== 1010574)
                      ?.map((item) => ({
                        img: item.img,
                        imgAlt: item.imgAlt,
                        title: item.title,
                        cat: item.catTitle,
                        date: item.date,
                        duration: item.duration,
                        link: item.link,
                      }))
                  : []
              }
              title="اخبار مرتبط"
              rowTitle="اخبار"
              allItemsLink="/newsroom"
            />
          )}
        </>
      )}
    </>
  );
};

export default SingleNewsPage;

export async function getServerSideProps(context) {
  if (context.query.newsSlug) {
    try {
      // news data deserializer
      const newsRes = await fetch(
        `${process.env.NEWSROOM_API_BASE_URL}/wp-json/wp/v2/posts?_embed&per_page=1&_fields=id,date,title,excerpt,slug,content,categories,_links.wp:term,_links.wp:featuredmedia,_embedded.wp:term,_embedded.wp:featuredmedia&slug=${context.query.newsSlug}&is_published=true&language=fa`
      );
      const newsData = await newsRes.json();
      if (newsData.length === 0) {
        return {
          redirect: {
            permanent: false,
            destination: "/404",
          },
          props: {},
        };
      }
      const newsDataObj = newsData[0];
      const refactoredNewsData = singleNewsDataDeserializer(newsDataObj);
      // end of news data deserializer

      // related news data deserializer
      const category = await newsData[0]?.categories[0];
      const relatedNews = await fetch(
        `${
          process.env.NEWSROOM_API_BASE_URL
        }/wp-json/wp/v2/posts/?_embed&status=publish&per_page=4&categories=${category}&exclude=${
          newsData[0]?.id,1010574
        }&_fields=id,date,title,excerpt,slug,categories,_links.wp:term,_links.wp:featuredmedia,_embedded.wp:term,_embedded.wp:featuredmedia&reqDate=${Date.now()}&is_published=true&language=fa`
      );
      const relNewsData = await relatedNews.json();
      const refactoredRelNewsData = relNewsData?.length
        ? relNewsData?.map((item) => newsThumbnailsDeserializer(item))
        : [];
      // related news data deserializer
      return {
        props: {
          // newsData: JSON.stringify(newsData),
          newsData: refactoredNewsData,
          relNewsData: JSON.stringify(refactoredRelNewsData),
          host: context.req.headers.host,
        },
      };
    } catch (error) {
      console.error(error);
      return {
        props: {
          newsData: null,
          relNewsData: null,
          host: context.req.headers.host,
        },
      };
    }
  }
}
